module.exports = __webpack_public_path__ + "img/logo6.2ae08105.png";